import React from 'react';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <p>©2024 Lisbon Business School. All rights reserved.</p>
    </footer>
  );
};

const styles = {
  footer: {
    padding: '10px',
    backgroundColor: '#333',
    color: '#fff',
    textAlign: 'center',
    width: '100%', // Ensures footer takes full width
  },
};

export default Footer;
